import { render } from "./TrialBalanceReport.vue?vue&type=template&id=5c08db90&scoped=true"
import script from "./TrialBalanceReport.vue?vue&type=script&lang=js"
export * from "./TrialBalanceReport.vue?vue&type=script&lang=js"

import "./TrialBalanceReport.vue?vue&type=style&index=0&id=5c08db90&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c08db90"]])

export default __exports__